import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
		reference: null,
	},

	getters:
	{
		hasReference: state => !!state?.reference?.id,
	},

	mutations:
	{
		[Types.REFERENCE_CLEAR](state)
		{
			state.reference = null
		},

        [Types.REFERENCE_DETAILS](state, reference)
		{
            state.reference = reference
        },
	},

	actions:
	{
		[Types.REFERENCE_CLEAR]({ commit })
		{
			commit(Types.REFERENCE_CLEAR)
		},

		[Types.REFERENCE_DETAILS]({ commit, dispatch }, { referenceNumber })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.get('/api/references/' + referenceNumber)
						.then
						(
							response =>
							{
								commit(Types.REFERENCE_DETAILS, response.data.data)
								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}